export default __webpack_public_path__ + "static/media/404.832b2e4f.svg";